import type { GradientValue } from '@elfsight/configurator-contracts';

export const getGradientValue = (gradient?: Partial<GradientValue>) => {
  const { colors, direction } = gradient ?? {};
  const stringColors =
    colors && colors.length > 0 ? colors.join(',') : undefined;

  return stringColors
    ? `linear-gradient(${direction}deg, ${stringColors})`
    : undefined;
};
